module.exports = __webpack_public_path__ + "img/img28.1f9b74ef.png";